import React from 'react'
import Image from '@hashicorp/react-image'
import fragment from './fragment.graphql'

/**
 * Localized from legacy web-components — @hashicorp/react-text-and-image v.2.0.3
 */

export default function TextAndImage({
	text,
	headline,
	image,
	reverseDirection,
}) {
	const textSection = (
		<div className="text" key={headline}>
			<h2>{headline}</h2>
			<div dangerouslySetInnerHTML={{ __html: text }} />
		</div>
	)

	const imageSection = (
		<div className="imgwrap" key={image.url}>
			<Image {...image} alt={image.alt} sizes="50vw" />
		</div>
	)

	return (
		<div
			className={
				reverseDirection
					? 'g-grid-container g-text-and-image reverse'
					: 'g-grid-container g-text-and-image'
			}
		>
			{reverseDirection
				? [imageSection, textSection]
				: [textSection, imageSection]}
		</div>
	)
}

TextAndImage.fragmentSpec = {
	fragment,
	dependencies: [Image],
}
